'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadBillingData = loadBillingData;
exports.loadInvoice = loadInvoice;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BILLING_INFO_LOAD = 'ms/billing/billing_load';
var BILLING_INFO_LOAD_SUCCESS = 'ms/billing/billing_load_success';
var BILLING_INFO_LOAD_FAIL = 'ms/billing/billing_load_fail';

var INVOICE_LOAD = 'ms/billing/invoice';
var INVOICE_LOAD_SUCCESS = 'ms/billing/invoice_load_success';
var INVOICE_LOAD_FAIL = 'ms/billing/invoice_load_fail';

var BILLING_INFO_APPEND = 'ms/billing/billing_append';
var BILLING_INFO_APPEND_SUCCESS = 'ms/billing/billing_append_success';
var BILLING_INFO_APPEND_FAIL = 'ms/billing/billing_append_fail';

var initialState = {
  currentPage: 1,
  pages: 0,
  billingInfo: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case BILLING_INFO_LOAD:
      return (0, _extends3.default)({}, state, {
        loadingBilling: true,
        loadingBillingError: null
      });

    case BILLING_INFO_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        billingInfo: action.result.charges,
        pages: action.result.pages,
        loadingBilling: false,
        loadingBillingError: null
      });

    case BILLING_INFO_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingBilling: false,
        loadingBillingError: action.error
      });

    case BILLING_INFO_APPEND:
      return (0, _extends3.default)({}, state, {
        loadingBilling: true,
        loadingBillingError: null
      });

    case BILLING_INFO_APPEND_SUCCESS:
      return (0, _extends3.default)({}, state, {
        billingInfo: state.billingInfo.concat(action.result.charges),
        currentPage: state.currentPage + 1,
        pages: action.result.pages,
        loadingBilling: false,
        loadingBillingError: null
      });

    case BILLING_INFO_APPEND_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingBilling: false,
        loadingBillingError: action.error
      });

    default:
      return state;
  }
}

// Action creators
function loadBillingData() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

  return function (dispatch) {
    return dispatch({
      types: append ? [BILLING_INFO_APPEND, BILLING_INFO_APPEND_SUCCESS, BILLING_INFO_APPEND_FAIL] : [BILLING_INFO_LOAD, BILLING_INFO_LOAD_SUCCESS, BILLING_INFO_LOAD_FAIL],
      promise: loadInvoices(page, limit)
    });
  };
}

function loadInvoice(invoice) {
  return {
    types: [INVOICE_LOAD, INVOICE_LOAD_SUCCESS, INVOICE_LOAD_FAIL],
    promise: loadInvoiceUrl(invoice)
  };
}

// Private
function loadInvoiceUrl(invoice) {
  return function (client) {
    var loadingPromise = client.get(invoice).then(function (result) {
      if (result && result.url) window.location = result.url;
    });

    return loadingPromise;
  };
}

// Private
function loadInvoices(page, limit) {
  var query = 'page=' + page + '&limit=' + limit;

  return function (client) {
    var loadingPromise = client.get('v1/payments/billing/self?' + query).then(function (result) {
      return {
        charges: result.charges || [],
        pages: result.pages
      };
    });

    return loadingPromise;
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/billing.js
// module id = 590
// module chunks = 0